/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext, useState} from 'react';
import MapBase from "./MapBase";
import useMapProps from "./useMapProps";
import MapPropsContext, {MapPropsProvider} from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {Tree} from "antd";
import {difference} from "../../utils";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetLegend from "./widgets/WidgetLegend";


// const ICON_MAPPING = {
//     '21': ['고정국', '고정국'],
//     '31': ['해안국', '해안국'],
//     '32': ['기지국', '기지국'],
//     '85': ['이동중계국', '이동중계국'],
//     '92': ['아마추어국',  '아마추어국'],
// };


const MapLandUsage = () => {
  const mapProps = useMapProps({
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: () => '고정국',
    }
  });

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetContainer>
          <WidgetLandUsage />
        </WidgetContainer>
        <WidgetLegend />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};


const WidgetLandUsage = () => {
  const {
    updateMapLayerNames,
  } = useContext(MapPropsContext);

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);

  const onCheck = useCallback(checkedKeys => {
    updateMapLayerNames('UQ114_SHP', checkedKeys.includes('UQ114_SHP'));

    setCheckedKeys(prevCheckedKeys => {
      const prevSet = new Set(prevCheckedKeys);
      const newSet = new Set(checkedKeys);

      difference(prevSet, newSet).forEach(key => {
        updateMapLayerNames(key, false);
      });

      difference(newSet, prevSet).forEach(key => {
        updateMapLayerNames(key, true);
      });

      return checkedKeys;
    });
  }, []);

  const onExpand = useCallback(expandedKeys => {
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  }, []);

  const renderTreeNodes = useCallback(data => {
    return data.map(item => {
      if ( item.children )
        return (
          <Tree.TreeNode title={item.title} key={item.key} dataRef={item}>
            {renderTreeNodes(item.children)}
          </Tree.TreeNode>
        );
      else
        return (
          <Tree.TreeNode key={item.key} {...item} />
        );
    });
  }, []);

  return (
    <div>
      <Tree checkable
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            autoExpandParent={autoExpandParent}
            onCheck={onCheck}
            checkedKeys={checkedKeys}
            onSelect={(selectedKeys, info) => setSelectedKeys(selectedKeys)}
            selectedKeys={selectedKeys}>
        {renderTreeNodes(TREE_DATA)}
      </Tree>
    </div>
  );
};


const TREE_DATA = [
  make_item({
    title: '용도지역도',
    children: [
      make_item({ title: '자연환경보전지역', key: 'UQ114_SHP' }), // areaname="AREA" name="UQ114" value="UQ114_SHP">
      make_item({ title: '농림지구', key: 'AF_DIS_SHP' }),
      make_item({ title: '상업지구', key: 'UQ111_COMM_SHP' }),
      make_item({ title: '녹지지구', key: 'UQ111_GR_SHP' }),
      make_item({ title: '공업지구', key: 'UQ111_IND_SHP' }),
      make_item({ title: '주거지구', key: 'UQ111_UR_SHP' }),
      make_item({ title: '관리지구', key: 'UQ112_SHP' }),
      make_item({ title: '학교환경위생정화구역', key: 'UOA_SHP' }),
    ]
  }),
  make_item({
    title: '용도지역지구도(기타)',
    children: [
      make_item({ title: '관광지', key: 'UO601_SHP' }),
    ],
  }),
  make_item({
    title: '택지개발지구도',
    children: [
      make_item({ title: '토지이용계획도', key: 'LHBLPN_SHP' }),
    ],
  }),
  make_item({
    title: '소방서관할구역',
    children: [
      make_item({ title: '소방서관할구역', key: 'USFSFFB_SHP' }),
    ],
  }),
  make_item({
    title: '보호시설도',
    children: [
      make_item({ title: '아동안전지킴이집', key: 'MGPRTFA_SHP' }),
    ],
  }),
  make_item({
    title: '연안정보도',
    children: [
      make_item({ title: '무역신항만', key: 'WGISTPNEWP_SHP' }),
    ],
  }),
  make_item({
    title: '도시계획시설도',
    children: [
      make_item({ title: '공공문화체육시설', key: 'UPISUQ155_SHP' }),
    ],
  }),
  // make_item({
  //   title: '수집데이터',
  //   children: [
  //   ],
  // }),
];


function make_item({ title, key, children }) {
  return { title, key: (key || title), children };
}


export default MapLandUsage;

